import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import {
  UserJobsService,
  WorkshopJobForUser
} from 'src/app/shared/services/user-jobs.service';
import { GoogleMapsLinkComponent } from '../../../shared/general/google-maps-link/google-maps-link.component';
import { WorkshopJobStatusLabelPipe } from '../../../shared/pipes/workshop-job-status-label.pipe';

@Component({
  selector: 'app-workshop-jobs-list',
  standalone: true,
  templateUrl: './workshop-jobs-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTable,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    GoogleMapsLinkComponent,
    AsyncPipe,
    DatePipe,
    WorkshopJobStatusLabelPipe,
    RouterLink
  ],
  providers: [UserJobsService]
})
export class WorkshopJobsListComponent {
  private route = inject(ActivatedRoute);
  private configService = inject(ConfigService);
  private router = inject(Router);
  private userJobsService = inject(UserJobsService);
  jobs$ = this.configService.currentUser.pipe(
    filter(Boolean),
    take(1),
    switchMap((user) =>
      this.userJobsService
        .getWorkshopJobs(user.id)
        .pipe(map((jobs) => jobs.workshop ?? []))
    )
  );

  lgColumns = [
    'id',
    'customer',
    'booked_in_date',
    'site_visit',
    'equipment',
    'status'
  ];

  smColumns = ['compact'];

  selectedId$ = this.route.queryParamMap.pipe(
    map((params) => {
      const id = params.get('selectedId');
      return id ? parseInt(id, 10) : null;
    })
  );
  selectedId = toSignal(this.selectedId$, { initialValue: null });

  constructor() {}

  selectJob(job: WorkshopJobForUser | null): void {
    this.router.navigate(['workshop', 'job', job.id]);
  }
}
